import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import Cookies from 'js-cookie';
import util from '@/page/util';

const init = () => {
  const environment = window?.__INITIAL_STATE__?.sentry?.env;
  const commit = window?.__INITIAL_STATE__?.commit;
  Sentry.init({
    dsn: 'https://5cba2ce03aef48cc9fe12eed7ac2b15d@sentry.cvtapi.com/158',
    integrations: [new BrowserTracing()],
    environment,
    tracesSampleRate: 0.4,
    release: `seewoedu-college-v2-pc-${commit}`,
    initialScope: (scope) => {
      if (window?.UserInfo) {
        scope.setUser({ ...window?.UserInfo, description: '用户已登陆' });
      } else if (Cookies.get('userId')) {
        scope.setUser({
          userId: Cookies.get('userId'),
          description:
            '用户登录情况不确定，考虑 1. 用户已登录但是异常的出现早于用户信息的请求 2. 用户未登录但是浏览器cookie有用户部分信息',
        });
      } else {
        scope.setUser({
          description: '用户未登陆',
        });
      }
      return scope;
    },
  });
};

const initSentry = () => {
  init();
  util.checkLogin(init);
};

export default initSentry;
